// extracted by mini-css-extract-plugin
export default {"title":"api-result_title__LRe6R","text":"api-result_text__KoOd6"};